<template>
  <div class="pre-posting">
    <v-img src="/img/social/social_06_1.png" class="stepper-image"></v-img>
    <div class="mb-6 padding-15 text-center">
      <h3 v-html="getMessage('social_title_pre_editing_profile')"></h3>
      <span
        v-html="getMessage('social_text_pre_editing_profile')"
        style="display:inline-block;margin-bottom:7px"
      ></span>
    </div>
    <div style="display:flex;justify-content:center">
      <v-btn
        @click="beforeEditingProfile"
        color="primary"
        class="hd-gradient"
        style="margin-bottom:25px"
      >
        Понятно
      </v-btn>
    </div>
  </div>
</template>
<script>
import { commonInitAppMethods } from "@/mixins/common-init-app-methods";

export default {
  mixins: [commonInitAppMethods],
  data() {
    return {
      step: 1
    };
  },
  methods: {
    beforeEditingProfile() {
      localStorage.setItem("before_editing_profile", JSON.stringify(false));
      this.$store.commit("account/update_before_editing_profile", false);
      this.$store.commit("account/update_before_editing_profile_dialog", false);
      this.$store.commit("account/call_dialog_edit_profile");
    }
  }
};
</script>
<style scoped>
.padding-15 {
  padding: 15px;
}
</style>
